module.exports = __webpack_public_path__ + "static/media/feishu_robot.2258d806.png";